// ViewFileModal.jsx

import React from "react";
import Modal from "react-modal";
import "./models.css";
import { ReactComponent as EditCrossIcon } from "../../assets/editCrossIcon.svg";

const ViewFileModal = ({ isOpen, closeModal, modalTitle, modalFileUrl }) => {
  const isImageFile = (url) => {
    // Example function to check if the URL ends with a common image file extension
    return /\.(jpeg|jpg|png|gif)$/i.test(url);
  };

  const customStylesAttachment = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    content: {
      width: window.innerWidth > "768" ? "40%" : "80%",
      maxHeight: "90vh",
      height: "auto",
      // minHeight: "20vh",
      margin: "auto",
      padding: window.innerWidth > "768" ? "20px 40px" : "20px 20px",
      borderRadius: "12px",
      textAlign: "center",
      // overflowY: "auto",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      // alignItems: "center",
      // justifyContent: "center"
    },
  };

  function extractAndFormatSegment(url) {
    const parts = url.split("/");

    const imagesIndex = parts.findIndex((part) => part === "Images");
    const folder = parts[imagesIndex + 1];

    if (folder) {
      return folder
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    }
    return "";
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={customStylesAttachment}
      contentLabel="Viexw File Modal"
    >
      <div style={{ textAlign: "right" }}>
        <EditCrossIcon style={{ cursor: "pointer" }} onClick={closeModal} />
      </div>
      <div className="view-file-model-container">
        <h4>{extractAndFormatSegment(modalFileUrl) || "IMAGE"}</h4>
        {isImageFile(modalFileUrl) ? (
          <div className="scrollable-image-container">
            <img src={modalFileUrl} alt={modalTitle} className="img-fluid" />
          </div>
        ) : null}
        <div style={{ textAlign: "center" }}>
          <button className="view-file-model-button" onClick={closeModal}>
            CLOSE
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ViewFileModal;
